var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008470(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75294 4.79492H2.83529C2.34854 4.79492 1.88173 4.98828 1.53755 5.33247C1.19336 5.67665 1 6.14347 1 6.63022V14.889C1 15.3758 1.19336 15.8426 1.53755 16.1868C1.88173 16.531 2.34854 16.7243 2.83529 16.7243H11.0941C11.5809 16.7243 12.0477 16.531 12.3919 16.1868C12.7361 15.8426 12.9294 15.3758 12.9294 14.889V13.9714",
    stroke: "#767C7C",
    strokeWidth: 1.52941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0114 2.96039L14.7644 5.71333M16.0353 4.41486C16.3967 4.05345 16.5998 3.56327 16.5998 3.05216C16.5998 2.54104 16.3967 2.05086 16.0353 1.68945C15.6739 1.32804 15.1837 1.125 14.6726 1.125C14.1615 1.125 13.6713 1.32804 13.3099 1.68945L5.58789 9.38392V12.1369H8.34083L16.0353 4.41486Z",
    stroke: "#767C7C",
    strokeWidth: 1.52941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008470);
export default __webpack_public_path__ + "static/media/Group 1000008470.e014897de85b7b2159ea1a10141f9402.svg";
export { ForwardRef as ReactComponent };